import styled from 'styled-components'
import { tokens } from 'styling/tokens'


export const AttendanceMonthlyCard = styled.div<{ color?: string }>`
    position: relative;
    width: 24px;
    height: 24px;
    border-radius: ${tokens.radius.chip};
    background: ${(props) => (props.color ? props.color + '24' : tokens.surface.inset)};
    border: 1px solid ${(props) => (props.color ? props.color + '5c' : tokens.border.hairline)};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => props.color ?? tokens.text.muted};
    font-size: 12px;
    font-weight: bold;
    transition: background 0.15s ease;

    &:hover {
        background: ${(props) => (props.color ? props.color + '38' : tokens.surface.raised)};
    }
`

export const AttendanceWeeklyCard = styled.div<{ color?: string }>`
    position: relative;
    border-radius: ${tokens.radius.control};
    background: ${(props) => (props.color ? props.color + '22' : tokens.surface.inset)};
    border: 1px solid ${(props) => (props.color ? props.color + '55' : tokens.border.hairline)};
    border-left: 3px solid ${(props) => props.color ?? tokens.border.strong};
    cursor: pointer;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    flex-direction: column;
    padding: 0 1rem;
    justify-content: center;
    transition: background 0.15s ease, border-color 0.15s ease;

    &:hover {
        background: ${(props) => (props.color ? props.color + '33' : tokens.surface.raised)};
    }

    .offset{
        background-color: ${tokens.surface.raised};
        padding: 1px 4px;
        border-radius: 5px;
    }
`

export const AttendanceOptionsWrapper = styled.div<{ right?: boolean, up?: boolean }>`
    width: 15rem;
    max-width: 100%;
    ${props => props.theme.content};
    backdrop-filter: blur(13.2px);
    border-radius: 10px;
    overflow: hidden;
`

export const AttendanceOption = styled.div`
 cursor: pointer;
    height: 32px;
    width: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s ease;
    &:hover {
      background: ${tokens.accent.base}
    }
`